<template>
  <div class="asset-icon bg-block-secondary rounded-full" :class="`--${size}`">
    <img v-if="instrument && !!instrument.logo" :src="`/images/brands/${instrument.logo}`" alt="" class="rounded-full">
    <AssetGroupIcon v-else-if="instrument" :asset-type="instrument.type" class="asset-icon md:p-2"/>
    <div v-else class="asset-icon md:p-2"></div>
  </div>
</template>

<script>
import AssetGroupIcon from "@/components/common/Investments/AssetGroupIcon";

export default {
  name: "AssetIcon",
  components: {AssetGroupIcon},
  props: {
    instrument: {
      type:Object,
      required:false,
      default: null
    },
    size: {
      type: String,
      default: 'small',
      validator: (val) => ['small', 'big'].includes(val)
    }
  }
}
</script>

<style scoped>
.--big {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
}
.--small {
  width: 2.4rem;
  min-width: 2.4rem;
  height: 2.4rem;
}
</style>